import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import App from './App'
import './index.css'
import reportWebVitals from './reportWebVitals'
import './assets/css/global.css'
import './assets/css/rhybus.css'
import './assets/icons/style.css'
import { msalConfig } from './authConfig'
import { PopupCloseContextProvider } from './store/contexts/popupclose-context'
import { UserDeviceContextProvider } from './store/contexts/UserDeviceContextProvider'

const msalInstance = new PublicClientApplication(msalConfig)
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <BrowserRouter>
    <MsalProvider instance={msalInstance}>
    <UserDeviceContextProvider>
    <PopupCloseContextProvider>
    <App />
    </PopupCloseContextProvider>
    </UserDeviceContextProvider>
  </MsalProvider>
  </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
